// @ts-nocheck
import { Events } from './constants';
import { version } from '../package.json';

/**
 * @param {WidgetStateContextType} widgetStateContextValue
 * @returns {Record<string, any>}
 */
export function createWidgetProxy(widgetStateContextValue) {
  return new Proxy(
    {
      /** @type {(EventListener): void} */
      onOpened: (callback) => window.addEventListener(Events.Opened, callback),
      /** @type {(EventListener): void} */
      onClosed: (callback) => window.addEventListener(Events.Closed, callback),
      /** @type {(boolean): void} */
      setOpen: (open) =>
        window.dispatchEvent(
          new CustomEvent(open ? Events.Open : Events.Close),
        ),
      toggle: () => window.dispatchEvent(new CustomEvent(Events.Toggle)),
      toggleConsent: () =>
        window.dispatchEvent(new CustomEvent(Events.ToggleConsent)),

      version: version || 'unknown',
      env: import.meta.env.MODE || 'prod',
      events: { ...Events },
    },
    {
      get: (obj, prop) => {
        if (prop === 'open') {
          const { open } = widgetStateContextValue;
          return open;
        }
        return Reflect.get(obj, prop);
      },
      set: () => false,
    },
  );
}
